import { render, staticRenderFns } from "./hours.vue?vue&type=template&id=8c852a56&scoped=true"
import script from "./hours.vue?vue&type=script&lang=js"
export * from "./hours.vue?vue&type=script&lang=js"
import style0 from "./hours.vue?vue&type=style&index=0&id=8c852a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c852a56",
  null
  
)

export default component.exports